import mapPagination from '../../utils/pagination';
import { _applyAction, actionButtons } from '../../utils/actions';
import _mapChildren from '../../utils/mapChildren';
import translations from '../../translations';
import placeholderHtml from './placeholderHtml';
import Vue from 'vue';
import { mapActions } from 'vuex';
export default {
  props: {
    includeActions: {
      default: false,
      type: Boolean
    },
    value: {
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      placeholder: '',
      isLoading: true
    };
  },
  computed: {
    attributes() {
      return {
        ref: 'vuetable',
        css: this.css,
        'pagination-path': '_pagination',
        'data-path': 'data',
        'track-by': 'uuid',
        fields: this.fields,
        transform: this.transform,
        'no-data-template': this.placeholder
      };
    },
    _mapChildren() {
      return _mapChildren;
    },
    selectedItems: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newValue) {
        if (
          newValue.length ===
          this.$refs[this.model + '-vuetable'].tableData.length
        ) {
          document.getElementById('checkAll-' + this.model).checked = true;
        } else {
          document.getElementById('checkAll-' + this.model).checked = false;
        }
        this.$emit('input', newValue);
      }
    }
  },
  mounted() {
    if (this.includeActions) {
      this.fields.push({
        name: 'actions',
        title: 'Actions'
      });
    }
    let self = this;

    // this.$refs[this.model + '-vuetable'].$on('vuetable:loaded', function() {
    //   self.isLoading = false;
    // });

    // this.$refs[this.model + '-vuetable'].$on('vuetable:loading', function() {
    //   self.isLoading = true;
    // });

    this.$refs['members-vuetable'].$on('vuetable:initialized', function() {
      self.initializeTable();
    });
    // this.$refs[this.model + '-vuetable'].$on(
    //   'vuetable:pagination-data',
    //   function(e) {
    //     self.onPaginationData(e);
    //   }
    // );
  },
  methods: {
    ...mapActions('toasts', ['_addToast']),
    onPaginationData(paginationData) {
      this.$refs[this.model + '-pagination'].setPaginationData(paginationData);
      //this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs[this.model + '-vuetable'].changePage(page);
    },
    transform(data) {
      data._pagination = mapPagination(data._pagination);
      let all = true;
      data.data.map(item => {
        if (this.value.some(e => e.uuid === item.uuid)) {
          item.selected = true;
        } else {
          all = false;
          item.selected = false;
        }
        return item;
      });
      if (all) {
        document.getElementById('checkAll-' + this.model).checked = true;
      } else {
        document.getElementById('checkAll-' + this.model).checked = false;
      }
      return data;
    },
    initializeTable() {
      // document
      //   .getElementById('checkAll-' + this.model)
      //   .addEventListener('change', this.checkAll);

      const sorters = document.getElementsByClassName('sorter');

      for (var i = 0; i < sorters.length; i++) {
        sorters[i].addEventListener('click', this.sortThis);
      }
    },
    sortThis(event) {
      this.sortColumn = event.target.dataset.column;
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    },
    checkAll(e) {
      this.$refs[this.model + '-vuetable'].tableData = this.$refs[
        this.model + '-vuetable'
      ].tableData.map(client => {
        client.selected = e.target.checked;
        return client;
      });
      this.updateSelectedItems();
    },
    updateSelectedItems() {
      let newSelectedItems = [];
      this.$refs[this.model + '-vuetable'].tableData.forEach(user => {
        if (user.selected) {
          newSelectedItems.push(user);
        }
      });
      this.selectedItems = newSelectedItems;
    },
    applyAction(action, data) {
      _applyAction(action, data).then(response => {
        if (this.model) {
          if (typeof translations.toasts[this.model][action] !== 'undefined') {
            this._addToast({ text: translations.toasts[this.model][action] });
          }
        }
        this.$refs[this.model + '-vuetable'].refresh();
        this.modal[action] = false;
      });
    },
    loading() {}
  }
};
